import { ReactNode } from 'react';
import clsx from 'clsx';

interface Props {
	children: ReactNode;
	className?: string;
}

export const ContainerBase: React.FC<Props> = ({ className, children }) => {
	return (
		<div
			className={clsx(
				'px-4 lg:px-[88px] 3xl:px-[252px] w-full min-h-full',
				className
			)}
		>
			{children}
		</div>
	);
};
